// extracted by mini-css-extract-plugin
export default {"notFoundHeading":"unauthorized_notFoundHeading__Csl7I","notFoundParagraph":"unauthorized_notFoundParagraph__K+5wB","arrowBtton":"unauthorized_arrowBtton__cb0Uo"};